<template>
  <Content title="我们的努力" :titleStyle="{ color: '#fff', position: 'relative', 'z-index': 3 }">
    <div
      id="professionCarousel"
      class="profession carousel slide text-white"
      data-ride="carousel"
      data-interval="false"
    >
      <div class="carousel-inner profession-container th-mt-100">
        <div
          v-for="(profession, i) in professions"
          :key="i"
          class="carousel-item th-px-44"
          :class="{ active: i === 0 }"
        >
          <p v-for="(desc, j) in profession.desc" :key="j" class="th-fs-26">{{ desc }}</p>
        </div>
      </div>
      <a class="carousel-control-prev" href="#professionCarousel" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#professionCarousel" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <button type="button" class="btn th-mt-42">
      <a class="lh-1" target="_blank" href="https://web.teyixing.com/passport/register">
        <div class="text-black">了解更多</div>
      </a>
    </button>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
import { professions } from './data'
export default {
  name: 'DesktopProfession',
  components: { Content },
  setup() {
    return { professions }
  },
}
</script>

<style lang="scss" scoped>
.content {
  background-image: url('/images/operation@2x.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 634px;
  position: relative;
  z-index: 1;
}

.content::before {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  content: ' ';
  background-color: rgba(2, 29, 93, 0.32);
  z-index: 2;
}

.profession {
  position: relative;
  z-index: 3;
  padding: 0 250px;
}

.carousel-item {
  p {
    line-height: 2;
  }
}

.carousel-control-prev,
.carousel-control-next {
  width: 8%;
}

.carousel-control-prev {
  left: -20px;
}
.carousel-control-next {
  right: -20px;
}

.btn {
  width: 310px;
  height: 42px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
  z-index: 3;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 77px;
}
</style>
